/**
 * MixtapeCollection object
 * @public
 * @extends {mm.Collection}
 * @return {Object} Instance of mm.MixtapeCollection
 */
mm.MixtapeCollection = function () {
  return mm.Collection({ url: "/mixtapes" })
}
